// extracted by mini-css-extract-plugin
export default {"h1":"Text_h1__VWatX","h2":"Text_h2__JcYE0","h3":"Text_h3__+OpY9","h4":"Text_h4__6NlY7","body":"Text_body__WL4U6","subtitle":"Text_subtitle__ZnVW9"};